<template>
    <v-card class="mb-3">
        <v-card-title class="headline">
            <v-icon
                left
                color="primary"
            >
                fas fa-file-invoice
            </v-icon>
            Invoice
        </v-card-title>
        <div class="pa-3">
            <key-value-table>
                <tbody>
                    <tr>
                        <td>Invoice Number</td>
                        <td>{{ invoice.invoiceNumber }}</td>
                    </tr>
                    <tr>
                        <td>Customer Number</td>
                        <td>{{ invoice.partnerNumber | showAbsence }}</td>
                    </tr>
                    <tr>
                        <td>Amount Paid</td>
                        <td>{{ invoice.amountPaid | currency }}</td>
                    </tr>
                    <tr>
                        <td>Sales Rep</td>
                        <td>{{ invoice.salesRep | showAbsence }}</td>
                    </tr>
                    <tr>
                        <td>Project Name</td>
                        <td>{{ invoice.projectName | showAbsence }}</td>
                    </tr>
                </tbody>
            </key-value-table>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        invoice: {
            type: Object,
            required: true
        }
    }
}
</script>

<style>

</style>
